import moment from 'moment';
import type transform from '../to/settings';

export default (settings: ReturnType<typeof transform>) => {

  settings.calendarExceptions = settings.calendarExceptions?.map(exception => {
    // the start time should not be later than 23:55 of the specified date
    let start = moment.utc(exception.start);
    if (start.hour() === 23 && start.minute() > 55) start = start.minute(55);

    // the end time should not be before 00:05 of the specified date, in such a case set it to the end of day
    // (this has to do with backwards compatibility with older versions)
    let end = moment.utc(exception.end);
    if (end.hour() === 0 && end.minute() < 5) end = end.endOf('day');

    return { ...exception, start, end };
  });

  return settings;
};
